module.exports = __webpack_public_path__ + "img/heading.7ab58b7b.svg";